module.exports = __webpack_public_path__ + "b197793fc505352ccc9df9db023d6ac2.png";